
import { defineComponent, PropType } from 'vue'
import { MetricType } from '~/types/metric'
import { Metric, MetricNamespaceTrend } from '~/types/types'

export default defineComponent({
  name: 'EmptyTrend',
  props: {
    dateRange: {
      type: String,
      default: '7d'
    },
    namespacesTrend: {
      type: Object as PropType<MetricNamespaceTrend>,
      required: true
    },
    metricMeta: {
      type: Object as PropType<{
        shortcode?: Metric['shortcode']
        name?: Metric['name']
        description?: Metric['description']
        supportsAggregateThreshold?: Metric['supportsAggregateThreshold']
      }>,
      required: true
    }
  },
  computed: {
    isAggregate(): boolean {
      return this.namespacesTrend.key === MetricType.aggregate
    }
  },
  methods: {
    updateFilter(newValue: string): void {
      this.$emit('update-filter', newValue)
    }
  }
})
